import { forEach, isEmpty, size } from 'lodash-es'

const SINGLE_PIN_ZOOM = 16

const fitMapToPins = ({
  map,
  googleMaps,
  pins,
  defaultCenter,
  defaultZoom,
}) => {
  if (isEmpty(pins)) {
    map.setZoom(defaultZoom)
    map.panTo(defaultCenter)
    return
  }

  const bounds = new googleMaps.LatLngBounds()
  forEach(pins, ({ geometry: { coordinates: [longitude, latitude] } }) =>
    bounds.extend({ lat: latitude, lng: longitude }),
  )

  if (size(pins) === 1) {
    map.panTo(bounds.getCenter())
    map.setZoom(SINGLE_PIN_ZOOM)
    return
  }

  map.fitBounds(bounds)
}

export default fitMapToPins
